import { ReactNode } from 'react';
import { cn, QueryableComponent, Stack, StackProps } from '@prenuvo/halo-foundation';

import { SidePanelHeader } from './side-panel-header.component';
import { SidePanelOverlay } from './side-panel-overlay.component';

interface SidePanelProps extends QueryableComponent {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: ReactNode;
  titleJustification?: StackProps['justification'];
}

export function SidePanel({
  children,
  'data-testid': dataTestId = 'fct-side-panel',
  isOpen,
  onClose,
  title,
  titleJustification = 'end',
}: SidePanelProps) {
  return (
    <Stack
      alignment="center"
      className="z-40 flex w-full"
      data-testid={dataTestId}
      justification="center"
      variant="vertical"
    >
      <SidePanelOverlay isOpen={isOpen}>
        <div
          className={cn(
            'flex flex-col w-1/2',
            'absolute right-0 h-[calc(100%-64px)] w-full bg-stone-800 dark:bg-stone-800 drop-shadow-2xl',
            'transition-all duration-300 ease-out',
            {
              'translate-y-full md:translate-x-full md:translate-y-0': !isOpen,
            },
          )}
        >
          <SidePanelHeader
            onCloseClick={onClose}
            title={title}
            titleJustification={titleJustification}
          />

          {children}
        </div>
      </SidePanelOverlay>
    </Stack>
  );
}
